import { Suspense } from "react";
import { Navigate, Outlet } from "react-router-dom";
import PageNotFound from "../layouts/PageNotFound/PageNotFound";
import HomePage from "../layouts/HomePage/HomePage";
import VenuesPage from "../layouts/VenuesPage/VenuesPage";
import BillsPage from "../layouts/BillsPage/BillsPage";
import Menu from "../layouts/Menu/Menu";
import MenuTypePage from "../layouts/Menu/MenuTypePage";
import MenuDishPage from "../layouts/Menu/MenuDishPage";
import Feedback from "../layouts/Feedback/Feedback";
import Drawer from "../components/Drawer/Drawer";
import TransparentDrawer from "../components/TransparentDrawer/TransparentDrawer";
import Summary from "../layouts/Summary/Summary";
import ReceiptPage from "../layouts/ReceiptPage/ReceiptPage";
import ReceiptSent from "../layouts/ReceiptSent/ReceiptSent";
import RestaurantScopeLayout from "../layouts/RestaurantScopeLayout/RestaurantScopeLayout";
import TableScopeLayout from "../layouts/TableScopeLayout/TableScopeLayout";
import OrderLayout from "../layouts/Order/OrderLayout";
import LoyaltyPage from "../layouts/Loyalty/LoyaltyPage";
import AccountPage from "../layouts/Account/AccountPage";
import TipPage from "../layouts/Tip/TipPage";
import AllergensPage from "../layouts/Account/AllergensPage";
import OrderMenuTypesPage from "../layouts/Order/OrderMenuTypesPage";
import OrderMenuTypePage from "../layouts/Order/OrderMenuTypePage";
import DishCustomizePage from "../layouts/Order/DishCustomizePage";
import CartPage from "../layouts/Order/CartPage";
import OrderConfirmedPage from "../layouts/Order/OrderConfirmedPage";
import OrderFailedPage from "../layouts/Order/OrderFailedPage";

function App() {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Outlet />
      <Drawer />
      <TransparentDrawer />
    </Suspense>
  );
}

const paid = false;

export const protectedRoutes = [
  {
    path: "/",
    element: <App />,
    children: [
      {
        // Applies the venue's theme to every screen below it.
        path: "restaurants/:restaurantId",
        element: <RestaurantScopeLayout />,
        children: [
          {
            // Owns the live table socket for the whole table session, so
            // moving between the bill and the ordering flow does not drop it.
            path: "tables/:tableId",
            element: <TableScopeLayout />,
            children: [
              {
                // The venue chrome: header image, burger menu, footer.
                element: (
                  <HomePage paid={paid}>
                    <Outlet />
                  </HomePage>
                ),
                children: [
                  {
                    index: true,
                    element: <VenuesPage />,
                  },
                  {
                    element: (
                      <>
                        <BillsPage paid={paid} />
                        <Outlet />
                      </>
                    ),
                    children: [
                      { path: "bills", element: <div /> },
                      { path: "pay-your-bill", element: <div /> },
                      {
                        path: "split-the-bill",
                        element: <div />,
                        children: [
                          { path: "equally", element: <div /> },
                          { path: "*", element: <Outlet /> },
                        ],
                      },
                      { path: "divide-bill-equally", element: <div /> },
                      { path: "*", element: <Outlet /> },
                    ],
                  },
                ],
              },
              {
                // Points live in this browser, but claiming a reward puts a
                // dish in the cart, so it belongs to the table scope.
                path: "loyalty",
                element: <LoyaltyPage />,
              },
              {
                // A tip with no bill behind it, for one person by name.
                path: "tips",
                element: <TipPage />,
              },
              {
                // The guest rather than the food: signing in, points, the
                // allergen list, and the legal and support links.
                path: "account",
                children: [
                  { index: true, element: <AccountPage /> },
                  { path: "allergens", element: <AllergensPage /> },
                ],
              },
              {
                // The ordering flow: full-screen, outside the venue chrome,
                // but still inside the table's socket scope.
                path: "order",
                element: <OrderLayout />,
                children: [
                  { index: true, element: <OrderMenuTypesPage /> },
                  {
                    // A menu type (breakfast, drinks); its categories are tabs
                    // inside the page rather than routes of their own.
                    path: "type/:menuTypeId",
                    element: <OrderMenuTypePage />,
                  },
                  { path: "dish/:dishId", element: <DishCustomizePage /> },
                  {
                    path: "cart",
                    element: <CartPage />,
                    children: [
                      // Token-only routes: the gradient Drawer keys off the
                      // last path segment and renders the checkout steps.
                      { path: "tip", element: <div /> },
                      { path: "payment", element: <div /> },
                    ],
                  },
                  { path: "confirmed", element: <OrderConfirmedPage /> },
                  { path: "failed", element: <OrderFailedPage /> },
                ],
              },
            ],
          },
          {
            path: "menu",
            children: [
              { index: true, element: <Menu /> },
              { path: "type/:menuTypeId", element: <MenuTypePage /> },
              { path: "dish/:dishId", element: <MenuDishPage /> },
            ],
          },
          {
            path: "feedback",
            element: <Feedback />,
          },
          {
            path: "summary",
            element: <Summary />,
          },
          {
            path: "get-receipt",
            element: <ReceiptPage />,
          },
          {
            path: "receipt-sent",
            element: <ReceiptSent />,
          },
        ],
      },
    ],
  },
  { path: "/not-found", element: <PageNotFound /> },
  { path: "*", element: <Navigate to="/not-found" replace /> },
];
